import { defineRecipe } from '@chakra-ui/react'

export const paymentOptionsContainer = defineRecipe({
  className: 'PaymentOptionsContainer',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    mb: 6,
  },
})
